import React from 'react';
import Alert from '@mui/material/Alert';

export class AlertComponent extends React.Component {
  render() {
    const { message, type, hideClose, handleClose } = this.props;

    return (
      <Alert variant="filled" severity={type} onClose={!hideClose ? handleClose : null} style={{marginBottom: '2em'}}>
        {message}
      </Alert>
    )
  }
}

export default AlertComponent;
